import { isPositionEvent } from '@tunasong/schemas'
import { formatTime } from '../../lib/index.js'
import type { RendererPlugin } from '../renderer.js'
import { LabelText } from './styles.js'

const Label: RendererPlugin = ({ laneHeight, event, pixelsPerSecond }) => {
  if (!isPositionEvent(event)) {
    return null
  }

  const labelPadding = 4
  const label = formatTime(event.start, { millis: false, minutePrefix: '' })

  const x = event.start * pixelsPerSecond + labelPadding
  const y = laneHeight * 2

  return (
    <LabelText x={x} y={y} fill={'var(--tuna-palette-text-primary)'}>
      {label}
    </LabelText>
  )
}

export default Label
